module.exports = __webpack_public_path__ + "static/php-a03ef944ca155ecd3f4f7a2ad1ccc3cd.png";